const TIME_ZONE = "Europe/Kyiv";

const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
});

const partsInKyiv = (instant) => Object.fromEntries(
    formatter.formatToParts(instant).filter((part) => part.type !== "literal").map(({ type, value }) => [type, Number(value)]),
);

export const formatDateInKyiv = (instant) => {
    const { year, month, day } = partsInKyiv(instant);
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
};

export const shiftDateByDays = (dateValue, days) => {
    const [year, month, day] = String(dateValue || "").split("-").map(Number);
    if (!year || !month || !day) return dateValue;
    const shifted = new Date(Date.UTC(year, month - 1, day + days));
    return `${shifted.getUTCFullYear()}-${String(shifted.getUTCMonth() + 1).padStart(2, "0")}-${String(shifted.getUTCDate()).padStart(2, "0")}`;
};

const offsetAt = (instant) => {
    const parts = partsInKyiv(instant);
    const localAsUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
    return localAsUtc - Math.floor(instant.getTime() / 1000) * 1000;
};

/** Build a timestamp for a calendar date using the current Kyiv wall-clock time. */
export const kyivDateTimeAtCurrentTime = (dateValue, now = new Date()) => {
    const [year, month, day] = String(dateValue || "").split("-").map(Number);
    if (!year || !month || !day) return dateValue;

    const { hour, minute, second } = partsInKyiv(now);
    const wallClockAsUtc = Date.UTC(year, month - 1, day, hour, minute, second);
    let instant = new Date(wallClockAsUtc);
    // Re-evaluate the zone offset at the target date so a DST boundary between
    // the two dates does not turn a calendar-time comparison into a 24-hour shift.
    for (let attempt = 0; attempt < 3; attempt += 1) {
        instant = new Date(wallClockAsUtc - offsetAt(instant));
    }

    const offsetMinutes = offsetAt(instant) / 60000;
    const sign = offsetMinutes >= 0 ? "+" : "-";
    const absoluteOffset = Math.abs(offsetMinutes);
    const offset = `${sign}${String(Math.floor(absoluteOffset / 60)).padStart(2, "0")}:${String(absoluteOffset % 60).padStart(2, "0")}`;
    return `${dateValue}T${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}:${String(second).padStart(2, "0")}${offset}`;
};

export const isTodayInKyiv = (dateValue, now = new Date()) => dateValue === formatDateInKyiv(now);

export const formatKyivTime = (dateTimeValue) => {
    const date = new Date(dateTimeValue);
    if (Number.isNaN(date.getTime())) return "";
    return new Intl.DateTimeFormat("ru-RU", {
        timeZone: TIME_ZONE,
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
    }).format(date);
};
